import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import GitHubIcon from '@material-ui/icons/GitHub';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import Header from './Header';
import MainFeaturedPost from './MainFeaturedPost';
import FeaturedPost from './FeaturedPost';
import Footer from './Footer';
import flowstacksvid from './flowstacksvid.mp4';
import gitgemsvid from './gitgemsvid.mp4'
import CFHvid from './CFH3.mov'
import Yetibookvid from './yetibookdemostefwong.mov'
import ColumbiaIBMBlockchainAcceleratorVid from './IBMColumbiaSiteVidStef.mov'
import Vivevid from './ViveProductDesignStefWongUX.mov'
import MusicPlayer from './MusicPlayer'
import BrandStatement from './BrandStatement'
import BrandStatement2 from './BrandStatement2'
import CTA from './CTA'
import TopCTA from './TopCTA';
import TopCTAAbout1 from './TopCTAAbout1';


const useStyles = makeStyles((theme) => ({
  mainGrid: {
    marginTop: theme.spacing(3),
  },
  mobile: {
    [theme.breakpoints.down('sm')]: {
      marginLeft: theme.spacing(0),
      marginRight: theme.spacing(0),
      paddingLeft: theme.spacing(0),
      paddingRight: theme.spacing(0),
    },
  },
}));

const sections = [

  { title: 'STEF', url: '#stef' },
  { title: 'About', url: '#about' },
  { title: 'Portfolio', url: '#portfolio' },
];


const mainFeaturedPost = {
  title: `Vision. Precision. Tenacity.`,
  description:
    '',
  image: 'https://instagram.fewr1-6.fna.fbcdn.net/v/t51.2885-15/sh0.08/e35/s750x750/10654896_1695862857369555_1268647052_n.jpg?_nc_ht=instagram.fewr1-6.fna.fbcdn.net&_nc_cat=103&_nc_ohc=NXtmx45UewsAX-2Xui1&oh=3112456b7851f5232f51bca89411e036&oe=5EE3CA66',
  // image3: `${photo}`,
  image3: 'https://images.unsplash.com/photo-1558591710-4b4a1ae0f04d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=774&q=80',

  // image5: 'https://images.unsplash.com/photo-1454789548928-9efd52dc4031?ixlib=rb-1.2.1&auto=format&fit=crop&w=1600&q=80',
  // image5: 'https://images.unsplash.com/photo-1541599468348-e96984315921?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjk0Mzg0fQ&auto=format&fit=crop&w=1555&q=80',
  image4: 'https://images.unsplash.com/photo-1566041510639-8d95a2490bfb?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=926&q=80',
  image2: 'https://images.unsplash.com/photo-1550353149-c124059ac8c4?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2700&q=80',
  image5: 'https://images.unsplash.com/photo-1558346648-9757f2fa4474?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1650&q=80',
  // image2: 'https://images.unsplash.com/photo-1439853949127-fa647821eba0?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=934&q=80',
  // image3: 'https://images.unsplash.com/photo-1483638994033-15b73fe7af18?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1600&q=80',
  // image3: 'https://images.unsplash.com/photo-1536624936085-23ae62846b66?ixlib=rb-1.2.1&auto=format&fit=crop&w=934&q=80',
  // image3: 'https://images.unsplash.com/photo-1485163819542-13adeb5e0068?ixlib=rb-1.2.1&auto=format&fit=crop&w=1834&q=80',
  // image3: 'https://images.unsplash.com/photo-1500964757637-c85e8a162699?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1678&q=80',

  // video: `${Yetibookvid}`,
  imageText: 'Image Text',
};

const mainFeaturedPost2 = {
  title: `Vision. Precision. Tenacity.`,
  description:
    '',
  image: 'https://instagram.fewr1-6.fna.fbcdn.net/v/t51.2885-15/sh0.08/e35/s750x750/10654896_1695862857369555_1268647052_n.jpg?_nc_ht=instagram.fewr1-6.fna.fbcdn.net&_nc_cat=103&_nc_ohc=NXtmx45UewsAX-2Xui1&oh=3112456b7851f5232f51bca89411e036&oe=5EE3CA66',
  image3: 'https://images.unsplash.com/photo-1550353149-c124059ac8c4?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2700&q=80',
  image4: 'https://images.unsplash.com/photo-1566041510639-8d95a2490bfb?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=926&q=80',
  image2: 'https://images.unsplash.com/photo-1550353149-c124059ac8c4?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2700&q=80',
  image5: 'https://images.unsplash.com/photo-1558346648-9757f2fa4474?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1650&q=80',
  imageText: 'Image Text',
};

const mainFeaturedPost3 = {
  title: `Vision. Precision. Tenacity.`,
  description:
    '',
  image: 'https://instagram.fewr1-6.fna.fbcdn.net/v/t51.2885-15/sh0.08/e35/s750x750/10654896_1695862857369555_1268647052_n.jpg?_nc_ht=instagram.fewr1-6.fna.fbcdn.net&_nc_cat=103&_nc_ohc=NXtmx45UewsAX-2Xui1&oh=3112456b7851f5232f51bca89411e036&oe=5EE3CA66',
  image3: 'https://images.unsplash.com/photo-1550353149-c124059ac8c4?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2700&q=80',
  image4: 'https://images.unsplash.com/photo-1566041510639-8d95a2490bfb?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=926&q=80',
  image2: 'https://images.unsplash.com/photo-1550353149-c124059ac8c4?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2700&q=80',
  image5: 'https://images.unsplash.com/photo-1558346648-9757f2fa4474?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1650&q=80',
  imageText: 'Image Text',
};

const featuredPosts = [

  {
    title: 'See the process',
    date: '',
    description:
      'Vive (Y-Combinator S15) ',
    video: `${Vivevid}`,
    image: 'https://images.unsplash.com/photo-1501854140801-50d01698950b?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1600&q=60',

    tag1: 'Product Design',
    tag2: 'UX Design',
    tag3: 'UI Design',
    tag4: 'Mobile App Design',
    tag5: 'Marketing Design',
    tag6: 'Visual Design',
    tag7: 'Sketch',
    tag8: 'User Flows',
    tag9: 'Adobe Creative Suite',
    imageText: 'Image Text',
    externalUrl: 'https://drive.google.com/file/d/1PSlNP1x-m8Kco02abgdagP0AiS3Mpr7r/view?usp=sharing',
    paragraph1: 'Led the end-to-end re-design of Vive, an exclusive beauty booking platform, from the main booking flow to the final checkout. Created responsive UX designs for the website and mobile app as the sole Product Designer. As a result of the redesign, time to complete booking and checkout could be completed in 30 seconds. Worked collaboratively with the CEO, Operations and Marketing Manager, and the team of global software engineers.',
  },

  {
    date: '',
    description:
      'Columbia IBM Blockchain',
    image: 'https://images.unsplash.com/photo-1501854140801-50d01698950b?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1600&q=60',
    video: `${ColumbiaIBMBlockchainAcceleratorVid}`,
    tag1: 'Front End Web Development',
    tag2: 'UX Design',
    tag3: 'UI Design',
    tag4: 'HTML',
    tag5: 'CSS',
    tag6: 'Javascript',
    imageText: 'Image Text',
    externalUrl: 'https://www.careforhealthcarenj.com',
    paragraph1: `While I was a UX Design and Growth Strategist at Constellation (TechStars '18), I was the sole designer and developer of this website for the Columbia | IBM Blockchain Accelerator, working in collaboration with teams at Columbia Technology Ventures and IBM Blockchain.`,
  },
  {
    title: 'See website',
    date: '',
    description:
      'Yetibook',
    image: 'https://images.unsplash.com/photo-1569179327757-dd6bcfeb164a?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1296&q=60',
    video: `${Yetibookvid}`,
    tag1: 'Full Stack Web Development',
    tag2: 'Responsive Design',
    tag3: 'React JS',
    tag4: 'Ruby on Rails',
    tag5: 'UI Design',
    tag6: 'UX Design',
    tag7: 'Social Network',
    tag8: 'Authentication',
    tag9: 'PostgreSQL',
    tag10: 'Product Development',
    imageText: 'Image Text',
    externalUrl: 'https://www.yetibook.com',
    // headerText: 'Headertext',
    paragraph1: 'Yetibook is a social media platform where you can vote on posts/videos. Posts are presented in order of most votes to least votes. Inspired by Reddit, ProductHunt, StackOverflow, Quora, and Facebook.',
    paragraph2: ' I developed this using Ruby on Rails and React.',
  },
  {
    title: 'See website',
    date: '',
    description:
      'FlowStacks',
    // image: 'https://images.unsplash.com/photo-1501854140801-50d01698950b?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1600&q=60',
    image: 'https://images.unsplash.com/photo-1501854140801-50d01698950b?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1600&q=60',
    video: `${flowstacksvid}`,
    tag1: 'Front End Web Development',
    tag2: 'Javascript',
    tag3: 'HTML',
    tag4: 'CSS',
    tag5: 'Product Development',
    tag6: 'StackOverflow API (StackExchange API)',
    imageText: 'Image Text',
    externalUrl: 'https://www.flowstacks.com',
    paragraph1: 'FlowStacks shows you multiple StackOverflow Q&A all at once, then provides you the top accepted answer for each one.',
    paragraph2: ' I developed this with vanilla HTML/CSS/Javascript and the StackExchange (StackOverflow) API. ',
    // paragraph3: 'The color scheme is inspired by dark mode code editor development environments which is less strenuous on the eyes in the long term.',
  },
  {
    title: 'See website',
    date: '',
    description:
      'GitGems',
    image: 'https://images.unsplash.com/photo-1474524955719-b9f87c50ce47?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1600&q=60',
    video: `${gitgemsvid}`,
    tag1: 'Front End Web Development',
    tag2: 'React JS',
    tag3: 'HTML',
    tag4: 'CSS',
    tag5: 'Javascript',
    tag6: 'GitHub API',
    imageText: 'Image Text',
    externalUrl: 'https://www.gitgems.com',
    // paragraph1: 'GitGems allows you to find open source code via GitHub projects and search for developers without needing to sign up or create a GitHub account.',
    paragraph2: 'GitGems is a pocket-GitHub that allows you to find open source code via GitHub projects and search for developers without needing to sign up or create a GitHub account.',
    paragraph3: ' I developed this with React and the GitHub API.',
  },
  {
  
    date: '',
    description:
      'Care for Healthcare',
    image: 'https://images.unsplash.com/photo-1501854140801-50d01698950b?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1600&q=60',
    video: `${CFHvid}`,
    tag1: 'Web Design',
    tag2: 'Web Development',
    tag3: 'Visual Design',
    tag4: 'Video',
    imageText: 'Image Text',
    // externalUrl: 'https://www.careforhealthcarenj.com',
    // headerText: 'Headertext',
    paragraph1: 'Care for healthcare is a nonprofit initiative dedicated to providing protective equipment such as face-masks to local hospitals and healthcare workers in need. I designed, developed, and launched the website and edited the main video that is sent to donors in garnering donations via SquareSpace. Within 10 days of the website and video being launched, the GoFundMe campaign generated 27 out of 89 new donations (+33% of campaign funds).',
  },



];


// const posts = [post1, post2, post3];

const sidebar = {
  title: 'Stef Wong',
  subtitle: 'About Stef Wong',
  description:
    `I'm a systematic micro-innovator and problem solver for digital design and technology, spanning but not limited to human-computer interaction design and visionary Minimum Viable Products. A New York native, I approach life with boldness, sensibility, and open-mindedness to culture.
      I'm restlessly driven to solve problems and build for innovative solutions. I believe that every generation undergoes a unique paradigm shift that enables us to realize new frontiers in the limits of humanity, and many of my efforts in life are dedicated to conscious initiatives to make better experiences more distributed where they were previously thought to be impossible. 
      As a mobile-web Product/UX Designer with a background in development, I'm a strategic architect of digital products. I've designed and coded this website with React, my favorite JavaScript library to date. I cultivate sophisticated solutions while embracing calculated risk and thoughtful experimentation. 
      I operate with systematic foresight, enduring resilience, and over 8 years of experience across UX Design, Product Management, Growth Strategy, Software Engineering, Video Production/Multimedia, Startups, and SaaS.
  `,
  // archives: [
  //   { title: 'March 2020', url: '#' },
  //   { title: 'February 2020', url: '#' },
  //   { title: 'January 2020', url: '#' },
  // ],
  social: [
    { name: 'LinkedIn', icon: LinkedInIcon, url: 'https://www.linkedin.com/in/stephaniemjwong/' },
    { name: 'GitHub', icon: GitHubIcon, url: 'https://github.com/stefwong/' },
  ],
};

export default function Blog() {
  const classes = useStyles();

  return (
    <React.Fragment>
      <CssBaseline />
      <Container className={classes.mobile} maxWidth="lg">
        <Header title="Stef" sections={sections} />
      </Container>
      <MainFeaturedPost post={mainFeaturedPost} />

      {/* <BrandStatement></BrandStatement> */}




      <TopCTAAbout1
        post={mainFeaturedPost3}
        social={sidebar.social}
      />

      <TopCTA post={mainFeaturedPost2} />
      <BrandStatement2></BrandStatement2>

      {/* <BrandStatement></BrandStatement> */}


      <Container className={classes.mobile} maxWidth="lg">
        <main>
          <Grid container spacing={4} id="portfolio" className="justify-center">
            {featuredPosts.map((post, index) => (
              <FeaturedPost key={`${post.title} ${index}`} post={post} />
            ))}
          </Grid>
        </main>
      </Container>
      <CTA></CTA>
      {/* <MusicPlayer></MusicPlayer> */}
      <Footer title="" description="I've developed this website with HTML/CSS/ReactJS." />
    </React.Fragment>
  );
}